module.exports = __webpack_public_path__ + "static/K_grau-a0a083c7349220ebe5c876c7ce1cff53.png";